import { render, staticRenderFns } from "./Comp64t3.vue?vue&type=template&id=1ec8cb06&scoped=true&"
import script from "./Comp64t3.vue?vue&type=script&lang=js&"
export * from "./Comp64t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp64t3.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Comp64t3.vue?vue&type=style&index=1&id=1ec8cb06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec8cb06",
  null
  
)

export default component.exports